/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddOptionCommand } from '../../models/add-option-command';
import { AddOptionCommandResult } from '../../models/add-option-command-result';

export interface ApiKpIsAddOptionPost$Params {
      body?: AddOptionCommand
}

export function apiKpIsAddOptionPost(http: HttpClient, rootUrl: string, params?: ApiKpIsAddOptionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AddOptionCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpIsAddOptionPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddOptionCommandResult>;
    })
  );
}

apiKpIsAddOptionPost.PATH = '/api/KPIs/AddOption';
